// @flow

import * as React from 'react';
import desktopBanner from 'app/images/globalLeaderboard/howitworks-epl-desktop.jpg';
import mobileBanner from 'app/images/globalLeaderboard/howitworks-epl-mobile.jpg';
import HowToPlay from 'app/components/leaderboard/HowToPlay';
import ResponsiveBanner from 'app/components/commons/ResponsiveBanner';

function EnglishPremierLeagueHowToPlay() {
  return (
    <div>
      <ResponsiveBanner desktopImage={desktopBanner} mobileImage={mobileBanner} />
      <HowToPlay playLink="/lobby/football/epl">
        <p>
          You must enter a minimum of 3 EPL Challenges to feature on the EPL Ultimate Champion
          Leaderboard and be eligible for a prize. Your Global Score determines your position on the
          Leaderboard. The Leaderboard will be finalized 48 hours after the Final of the EPL
          allowing for any adjustments from our data providers. Your account must be verified before
          you can receive your prize. All prizes will be distributed after the 19/12/18 once token
          generation event has occurred. Prizes will be redeemable for your local currency after the
          19/12/18 through designated partnered exchanges.
        </p>
        <p>
          In the case of a tie, the member who has entered more EPL Challenges wins. If there is
          still a tie, the winner will be the member who joined PlayChip Fantasy first. The Second
          Chance Draw will occur 2 weeks after the finalisation of the leaderboard has taken place.
          All members who feature on the leaderboard at the end of the season will be sent an email
          which will require a response to be eligible for your prize.
        </p>
        <p>
          PlayChip Fantasy reserves the right to publish winner’s details on our site, in our
          newsletter and/or our marketing material. By entering any EPL Challenge you give us this
          right. PlayChip Fantasy may share your information with 3rd parties for the purposes of
          running this promotion and delivering your prize.
        </p>
      </HowToPlay>
    </div>
  );
}

export default EnglishPremierLeagueHowToPlay;
